export function normalizer(value: string): string {
  return value
    .trim() // Remove espaços sobrando
    .toLowerCase() // Converte tudo em minúsculo
    .normalize('NFD') // Separa acentos das letras
    .replace(/[\u0300-\u036f]/g, ''); // Remove acentos
}
